import React from 'react';

const Hawaii = () => {
  return (
    <div>
      
    </div>
  );
}

export default Hawaii;
